import React from 'react';
import { useTranslate } from '../../contexts/languageContext';
import styled from 'styled-components/macro';

const EstadisticasConsolidadoTabla_Cabecera = props => {
  const t = useTranslate();
  return (
    <>
      <FilaAños>
        <Año />
        <Año>2022</Año>
        <Año>2018</Año>
        <Año>2014</Año>
      </FilaAños>
    </>
  );
};

const FilaAños = styled.tr`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-bottom: 1px solid #dadada;
`;
const Año = styled.th`
  width: 33%;
  text-align: right;
  // border: 1px solid red;
`;

export default EstadisticasConsolidadoTabla_Cabecera;
